import { render, staticRenderFns } from "./HeadInfo.vue?vue&type=template&id=cca3355c"
import script from "./HeadInfo.vue?vue&type=script&lang=js"
export * from "./HeadInfo.vue?vue&type=script&lang=js"
import style0 from "./HeadInfo.vue?vue&type=style&index=0&id=cca3355c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports